import { Component, Element, Event, h, Host, Prop } from '@stencil/core';
/**
 *@slot tile-heading - The content placed in will appear in the upper half of the tile if the content is also filled, else appear in the tile by itself
 *@slot tile-content - The content placed in will appear in the lower half of the tile if the heading is also filled, else appear in the tile by itself
 */
export class TileComponent {
  constructor() {
    /**
     * Will show an "active" blue border if true around the tile
     */
    this.active = false;
    /**
     * Will show a box shadow on hover if true
     */
    this.hoverable = true;
    /**
     * Name for the tile, used to identify it in onclick events
     */
    this.tileId = 'tile';
    /**
     * Provide screen reader users with additional context or to convey information not available in HTML alone
     */
    this.srContext = '';
    /**
     * Theme colour to apply to the top edge of the tile
     */
    this.theme = 'none';
  }
  handleClick() {
    this.tileClicked.emit(this.tileId);
  }
  componentWillLoad() {
    this.hasHeadingSlot = !!this.hostElement.querySelector('[slot="tile-heading"]');
    this.hasContentSlot = !!this.hostElement.querySelector('[slot="tile-content"]');
  }
  render() {
    return (h(Host, { onClick: () => this.handleClick() },
      h("div", { class: { tile: true, 'tile--active': this.active, 'tile--hoverable': this.hoverable, ['tile__theme--' + this.theme]: true } },
        h("agl-ds-segmented-container", null,
          this.hasHeadingSlot && (h("div", { slot: "section-1" },
            h("slot", { name: "tile-heading" }))),
          this.hasContentSlot && (h("div", { slot: "section-2" },
            h("slot", { name: "tile-content" })))))));
  }
  static get is() { return "agl-ds-tile"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() { return {
    "$": ["tile.component.scss"]
  }; }
  static get styleUrls() { return {
    "$": ["tile.component.css"]
  }; }
  static get properties() { return {
    "active": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Will show an \"active\" blue border if true around the tile"
      },
      "attribute": "active",
      "reflect": false,
      "defaultValue": "false"
    },
    "hoverable": {
      "type": "boolean",
      "mutable": false,
      "complexType": {
        "original": "boolean",
        "resolved": "boolean",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Will show a box shadow on hover if true"
      },
      "attribute": "hoverable",
      "reflect": false,
      "defaultValue": "true"
    },
    "tileId": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Name for the tile, used to identify it in onclick events"
      },
      "attribute": "tile-id",
      "reflect": false,
      "defaultValue": "'tile'"
    },
    "srContext": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": true,
      "docs": {
        "tags": [],
        "text": "Provide screen reader users with additional context or to convey information not available in HTML alone"
      },
      "attribute": "sr-context",
      "reflect": false,
      "defaultValue": "''"
    },
    "theme": {
      "type": "string",
      "mutable": false,
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      },
      "required": false,
      "optional": false,
      "docs": {
        "tags": [],
        "text": "Theme colour to apply to the top edge of the tile"
      },
      "attribute": "theme",
      "reflect": false,
      "defaultValue": "'none'"
    }
  }; }
  static get events() { return [{
      "method": "tileClicked",
      "name": "tileClicked",
      "bubbles": true,
      "cancelable": true,
      "composed": true,
      "docs": {
        "tags": [],
        "text": "Emits an event containing the `tileId` property when tile is clicked"
      },
      "complexType": {
        "original": "string",
        "resolved": "string",
        "references": {}
      }
    }]; }
  static get elementRef() { return "hostElement"; }
}
